import tagColor from './tagColor'
export default tagColor
